import { ImageVisual } from './ContentBlockVisuals.jsx';
import { imagePresentation } from './contentPresentation.js';
import { NodeViewWrapper } from '@tiptap/react';
import { ImagePlus } from 'lucide-react';
import { useContentEditorContext } from './ContentEditorContext.jsx';
import { contentEditorNodeEditable } from './contentEditorSelectionLocks.js';

export default function ContentImageNodeView({ node, editor, getPos, selected }) {
  const attrs = node.attrs;
  const context = useContentEditorContext();
  const canChoose = () => Boolean(context?.openImagePicker) && context?.mediaAvailable !== false && contentEditorNodeEditable(editor, node, getPos(), context);
  const pickerDisabled = !canChoose();
  const choose = () => {
    if (!canChoose()) return;
    const position = getPos();
    editor.commands.setNodeSelection(position);
    editor.commands.focus();
    context?.openImagePicker?.({ position, initialTab: 'upload' });
  };
  const { root } = imagePresentation(attrs);
  const roles = [attrs.isCoverImage ? 'Cover' : '', attrs.isSocialImage ? 'Social' : ''].filter(Boolean);
  return <NodeViewWrapper as="figure" data-content-image="" data-image-alignment={attrs.alignment || 'default'} data-image-preset={attrs.preset || 'standard'} className={`mts-editor-image-node mts-content-image relative ${root.className}${selected ? ' is-selected' : ''}`} style={root.style}>
    {roles.length ? <div contentEditable={false} className="pointer-events-none absolute left-2 top-2 z-10 flex gap-1" aria-label={`Image roles: ${roles.join(', ')}`}>{roles.map((role) => <span key={role} className="rounded-full bg-violet-700 px-2 py-1 text-[10px] font-bold uppercase tracking-wide text-white shadow">{role}</span>)}</div> : null}
    {attrs.src ? <ImageVisual attrs={attrs} authoring/> : <button type="button" disabled={pickerDisabled} contentEditable={false} className="mts-editor-image-placeholder" onClick={choose} aria-label="Upload image"><ImagePlus size={40} strokeWidth={1.75} aria-hidden="true"/><span>Upload image</span></button>}
  </NodeViewWrapper>;
}
